export const FlexiSetsQueryKeys = {
	all: ['flexi-sets'] as const,
	search: (companyHotelId: number) => [...FlexiSetsQueryKeys.all, 'detail', companyHotelId] as const,
	competitorsGroup: (companyHotelId: number, competitorsGroupId: number) => [...FlexiSetsQueryKeys.all, 'competitorsGroup', companyHotelId, competitorsGroupId] as const,
};